// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import './style/do-css.css'
import './style/normalize.css'
import api from './http'
// import VConsole from 'vconsole'

// const vConsole = new VConsole()
// console.log(vConsole.version)

Vue.use(VueRouter)
Vue.use(iView)
Vue.use(api)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js